import { api } from '../initFetch'

export const getToken = async (code) => {
  const res = await api.get(`/p4m/UserInfo/GetPdf4meToken?idToken=${code}`)
  return res.json
}
